/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReImportSpecification } from './ReImportSpecification';
import {
    ReImportSpecificationFromJSON,
    ReImportSpecificationFromJSONTyped,
    ReImportSpecificationToJSON,
    ReImportSpecificationToJSONTyped,
} from './ReImportSpecification';

/**
 * 
 * @export
 * @interface ReportCreateRequest
 */
export interface ReportCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportCreateRequest
     */
    reportConfigKey: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReportCreateRequest
     */
    storeInDocuments?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReportCreateRequest
     */
    referenceDate?: number;
    /**
     * The ISO 639 code for the language of the report
     * @type {string}
     * @memberof ReportCreateRequest
     */
    language?: string;
    /**
     * Triggers a re-import of these specifications
     * @type {Array<ReImportSpecification>}
     * @memberof ReportCreateRequest
     */
    reImportSpecifications?: Array<ReImportSpecification>;
}

/**
 * Check if a given object implements the ReportCreateRequest interface.
 */
export function instanceOfReportCreateRequest(value: object): value is ReportCreateRequest {
    if (!('reportConfigKey' in value) || value['reportConfigKey'] === undefined) return false;
    return true;
}

export function ReportCreateRequestFromJSON(json: any): ReportCreateRequest {
    return ReportCreateRequestFromJSONTyped(json, false);
}

export function ReportCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reportConfigKey': json['reportConfigKey'],
        'storeInDocuments': json['storeInDocuments'] == null ? undefined : json['storeInDocuments'],
        'referenceDate': json['referenceDate'] == null ? undefined : json['referenceDate'],
        'language': json['language'] == null ? undefined : json['language'],
        'reImportSpecifications': json['reImportSpecifications'] == null ? undefined : ((json['reImportSpecifications'] as Array<any>).map(ReImportSpecificationFromJSON)),
    };
}

export function ReportCreateRequestToJSON(json: any): ReportCreateRequest {
    return ReportCreateRequestToJSONTyped(json, false);
}

export function ReportCreateRequestToJSONTyped(value?: ReportCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reportConfigKey': value['reportConfigKey'],
        'storeInDocuments': value['storeInDocuments'],
        'referenceDate': value['referenceDate'],
        'language': value['language'],
        'reImportSpecifications': value['reImportSpecifications'] == null ? undefined : ((value['reImportSpecifications'] as Array<any>).map(ReImportSpecificationToJSON)),
    };
}

